import React, { useEffect, useState } from "react";
import { connect } from "react-redux";
import axios from "axios";
import { API_URL } from "../../../../config";
import BcValueCircle from "./BcValueCircle";

// "Inventory Over 90" widget — green circle showing the total cost value of
// remaining inventory aged over 90 days (excluding the Commercial cost center),
// read live from Business Central. Firm-wide metric (not salesperson-scoped).
const InventoryOver90 = ({ auth: { auth } }) => {
  const [value, setValue] = useState(null);

  const token = auth && auth[0] ? auth[0].token : null;

  useEffect(() => {
    if (!token) return;
    axios
      .get(`${API_URL}/Dashboard/api/Dashboard/InventoryOver90`, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((res) => {
        const rows = Array.isArray(res.data)
          ? res.data
          : (res.data && res.data.result) || [];
        setValue(rows[0] ? rows[0].value : 0);
      })
      .catch((err) => {
        console.warn("Could not load Inventory Over 90:", err.message);
      });
  }, [token]);

  return <BcValueCircle title="Inventory Over 90" value={value} />;
};

const mapStateToProps = ({ auth }) => ({ auth });

export default connect(mapStateToProps)(InventoryOver90);
